import { AutocompleteInput } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  container: {
    flexGrow: 1,
    position: 'inherit',
  }
})
export default withStyles(styles)(AutocompleteInput)